export default __webpack_public_path__ + "static/media/plus.ab41067c.svg";